import { render } from "./EnvioSend.vue?vue&type=template&id=5b9001d0"
import script from "./EnvioSend.vue?vue&type=script&lang=js"
export * from "./EnvioSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__